import { Injectable } from '@angular/core';
import { DataService } from "../../../../../shared/services/data.service";
import { StorageService } from "../../../../../shared/services/storage.service";
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Result } from "../../../../../shared/model/response.model";
import {AddRequirementModel} from "../../../requirements/popup/add-requirement/add-requirement.model"
import {URLS} from "src/app/components/sales/sales-api-constants"
@Injectable({
  providedIn: 'root'
})
export class RequirementsService {
  public recordPass = new BehaviorSubject(undefined);
  public id:string='';
  private selectedDataSubject = new BehaviorSubject<any>(undefined);
  onRowClicked = new BehaviorSubject<boolean>(false);
  onExpandClicked = new BehaviorSubject<boolean>(true);
  public activeTab = new BehaviorSubject<any>(undefined);
  public hasApprovedSource : boolean = false;
  public hasPrioritizedSource: boolean = false;
  private count = new BehaviorSubject<any>(undefined);
  public tabCountDetails = new BehaviorSubject(undefined);
  setCount(data: any): void {
    this.count.next(data);
  }
  getCount(): Observable<any> {
    return this.count.asObservable();
  }

  setSelectedData(data: any): void {
    this.selectedDataSubject.next(data);
  }


  getSelectedData(): Observable<any> {
    return this.selectedDataSubject.asObservable();
  }

  constructor(private service: DataService,
    public storageService:StorageService) { }
  insertRequirementData(insertRequirementData: AddRequirementModel): Observable<Result> {
    let url = URLS.requirement.insert;
    const myjson = JSON.stringify(insertRequirementData);
    return this.service.post(url, insertRequirementData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateRequirementData(insertRequirementData: AddRequirementModel): Observable<Result> {
    let url = URLS.requirement.update;
    return this.service.post(url, insertRequirementData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getAllRequirementDropdown(): Observable<Result> {
    let url = URLS.dropdown.getAllDropdown;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllMPNDropdownList(): Observable<Result> {
    let url = URLS.dropdown.getAllMPNList;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  getRequirementByMPN(id:string): Observable<Result> {
    let url = URLS.requirement.getByMPN + id;
    return this.service.get(url).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  getRequirementNo(): Observable<Result> {
    let url = URLS.requirement.getNo;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  getRequirementById(id:string): Observable<Result> {
    let url = URLS.requirement.getById + id;
    return this.service.get(url).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  getRequirementDetailsById(id:string): Observable<Result> {
    let url = `app/requirement/getRequirementDetailsById?id=${id}`;
    return this.service.get(url).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  getAllRFQsSentData(data: any,id:string): Observable<Result> {
    let url = `app/requirement/getRFQsSentDetailsById?id=${id}`;
    return this.service.post(url,data).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllRelatedRequirement(data: any): Observable<Result> {
    let url = `app/requirement/getAllRelatedRequirementListByRequirementId`;
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
getAvailableList(data: any): Observable<Result> {
    let url = 'app/requirement/getAvailableSourcesByRequirementId';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
getApprovedList(data: any): Observable<Result> {
    let url = 'app/requirement/getApprovedSourcesByRequirementId';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
getPotentialList(data: any): Observable<Result> {
    let url = 'app/requirement/getPotentialSourcesByRequirementId';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
getFullfillmentSettingsByCompanyId(id: string): Observable<Result> {
    let url = `app/company/getFullfillmentSettingsByCompanyId?CompanyId=${id}`;
    return this.service.get(url).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
markReadyToQuote(data: any): Observable<Result> {
    let url = 'app/requirement/markReadyToQuote';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
markNoBid(data: any): Observable<Result> {
    let url = 'app/requirement/markNoBid';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
removeReadyStatus(data: any): Observable<Result> {
    let url = 'app/requirement/removeReadyStatus';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  toggleSourceApproval(data: any): Observable<Result> {
    let url = 'app/requirement/toggleSourceApproval';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  removeSourceApproval(data: any): Observable<Result> {
    let url = 'app/requirement/removeSourceApproval';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  clearPriority(data: any): Observable<Result> {
    let url = 'app/requirement/clearPriority';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  priorityConfirmQuantity(data: any): Observable<Result> {
    let url = 'app/requirement/priorityConfirmQuantity';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getTabCountById(data: any): Observable<Result> {
    let url = "app/requirement/getTabCountByRequirementIdAndTabName";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }    
  extendExpireOffer(data: any): Observable<Result> {
    let url = "app/requirement/expireOffer";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getIncludedRfqVendors(data: any): Observable<Result> {
    let url = "app/sourcing/getIncludedRfqVendors";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  updateRfqVendor(data: any): Observable<Result> {
    let url = "app/requirement/updateRfqVendor";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
